import { useState, useMemo, useEffect, useRef } from 'react';
import '../../../assets/css/StudentDashboard.css'

import SearchBar from '../../../Component/SearchBar.js';
import { SuccessfulPopup } from '../../../Component/Modals/SuccessfulPopup.js';
import Table from '../../../Component/Table.js';
import { useNavigate, useNavigation } from 'react-router-dom';
import { Deletedata, getBlob, getData, patchData, postBlob, Postdata, PostFileData, updateData } from '../../../API/GlobalApi.js';
import { ReceivePayment } from '../../../Component/Modals/ReceivePaymentModal.js';
import exporticon from '../../../assets/icons/export-data.svg';
import edit from '../../../assets/icons/editnew.svg';

import { handlePaginate } from '../../../Utils/handlePagination.js';
import { FeePlans } from '../../../Component/Modals/FeePlansModal.js';

import ConfirmationModal from '../../../Component/Modals/ConfirmationModal.js';
// import FeeNoticeCourseWise from '../../../Component/Modals/FeeNoticePrint.js';
import { formatDateDDMMYYYY, formatDateDDMMYYYYHHMMSS } from '../../../Utils/data&dateTime.js';
import SpinnerLoader from '../../../Utils/Spinner.js';
import SearchingBar from '../../../Utils/Searching.js';
import Notifier from '../../../Utils/notify.js';
import OtpModal from '../../../Component/Modals/DiscountOtpInput.js';
import AdvanceTable from '../../../Utils/AdvanceTables.js';
import DiscountNotice from '../../../Component/Modals/DiscountNoticePrint.js';
import { AddBankAccounts } from '../../../Component/Modals/AddBankAccounts.js';
import TableSkeleton from '../../../Utils/TableSkeleton.js';


const ManageBankAccounts = () => {



    const skipSpinnerRef = useRef(false);

    const [isLoading, setIsLoading] = useState(true);
    const [isSearchLoading, setSearchLoading] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [institutionsBankData, setInstitutionsBankData] = useState([])
    const [selectedInstitutionsBank, setSelectedInstitutionsBank] = useState([]);
    const [filterInstitutesBank, setFilterInstitutesBank] = useState([])
    const pageSize = 10;
    const pageCounts = Math.ceil(totalCount / pageSize);
    const [modalMode, setModalMode] = useState('create');
    const [filterQueryString, setFilterQueryString] = useState('');
    const navigate = useNavigate();
    const [addBankAccountsModal, setAddBankAccountsModal] = useState(false)
    const [filterLoading, setFilterLoading] = useState(false);

    const openBankAccountsAddModal = () => {
        setSelectedInstitutionsBank(null);
        setModalMode('create');
        setAddBankAccountsModal(true)
    }
    const closeBankAccountsAddModal = () => {
        setAddBankAccountsModal(false)
        setSelectedInstitutionsBank(null);

    }

    const getInstitutionsBank = async (page = 0) => {
        const pageNumber = page + 1;
        const url = filterQueryString
            ? `finance/institution-bank-accounts/?${filterQueryString}&page=${pageNumber}`
            : `finance/institution-bank-accounts/?page=${pageNumber}`;
        if (!skipSpinnerRef.current) {
            if (isInitialLoad) setIsLoading(true);
            else setSearchLoading(true);
        }
        try {
            const response = await getData(url);

            setInstitutionsBankData(response);
            setFilterInstitutesBank(response)


            // if (data.length > 0) {
            //     // const firstPOId = pos[0].id;
            //     // await getPOById(firstPOId);
            // }
        } catch (error) {
            Notifier.error(error)
            setInstitutionsBankData([]);
            setTotalCount(0);
        } finally {
            if (!skipSpinnerRef.current) {
                if (isInitialLoad) {
                    setIsLoading(false);
                    setIsInitialLoad(false);
                } else {
                    setSearchLoading(false);
                }
            }

            // ✅ Always reset after fetch
            skipSpinnerRef.current = false;
        }
    };


    const currentPageRef = useRef(currentPage);

    useEffect(() => {
        currentPageRef.current = currentPage;
        getInstitutionsBank(currentPage);
    }, [currentPage, filterQueryString]);



    const handleRowClick = async (userId, row) => {
        try {
            setSelectedInstitutionsBank(row?.original)
        } catch (error) {
        }
    };







    const sourceData = useMemo(() => {
        return filterQueryString ? filterInstitutesBank : institutionsBankData;
    }, [institutionsBankData, filterInstitutesBank, filterQueryString]);



    const formattedData = useMemo(() => {
        return sourceData?.map((bank) => ({
            id: bank.id,
            bankId: bank.bank,
            account_type: bank.account_type,
            account_holder_name: bank.account_holder_name,
            default_online_account: bank.default_online_account,
            account_number: bank.account_number,
            bank_name: bank.bank_name,
            branch_name: bank.branch_name,
            ifsc_code: bank.ifsc_code,
            micr_code: bank.micr_code,
            is_default: bank.is_default,
            is_active: bank.is_active,
            handleRowClick, // for table row action
        }));
    }, [sourceData]);





    const searchInputRef = useRef(null);
    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, []);


    const handleStatus = async (row) => {

    };



    const handleEditClick = (row) => {
        setSelectedInstitutionsBank(row);
        setModalMode('edit');
        setAddBankAccountsModal(true)
    };






    const columns = useMemo(
        () => [

            {
                Header: "Account Holder Name",
                accessor: 'account_holder_name',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: 'pointer' }}
                        // onClick={() => {
                        //   navigate(`/studentDashboard/StudentFullProfile/${row.original.id}`);
                        // }}
                        onClick={() => handleRowClick(row.original.id, row)}                     >
                        <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>
                            {row.original.account_holder_name}
                        </p>


                    </div>
                ),
            },
            {
                Header: () => <p style={{ textAlign: 'left' }}>Account Number</p>,
                accessor: 'account_number',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div >
                        <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row.original.account_number}</p>
                    </div>
                )
            },



            {
                Header: () => <p style={{ textAlign: 'left' }}>Bank Name</p>,
                accessor: 'bank_name',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                        {row.original.bank_name}
                    </div>
                )
            },

            {
                Header: () => <p style={{ textAlign: 'left' }}>Branch Name</p>,
                accessor: 'branch_name',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                        {row.original.branch_name}
                    </div>
                )
            }, {
                Header: () => <p style={{ textAlign: 'left' }}>IFSC code</p>,
                accessor: 'ifsc_code',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                        {row.original.ifsc_code}
                    </div>
                )
            },
            {
                Header: "Account Type",
                accessor: "account_type",
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                        {row.original.account_type}
                    </div>
                )
            },
            {
                Header: "Default",
                accessor: "is_default",
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                        {row.original.is_default ? "True" : "False"}
                    </div>
                )
            },
            {
                Header: "Default For PG Acc",
                accessor: "default_online_account",
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                        {row.original.default_online_account ? "True" : "False"}
                    </div>
                )
            },



            {
                Header: "Status",
                accessor: "is_active",
                disableSortBy: true,
                Cell: ({ value }) => (
                    <span
                        style={{
                            color: value ? "green" : "orange",
                            fontWeight: "500"
                        }}
                    >
                        {value ? "Active" : "Inactive"}
                    </span>
                )
            },


            {
                Header: 'Action',
                disableSortBy: true,
                Cell: ({ row }) => {
                    return (
                        <div
                            style={{ display: 'flex', gap: '10px' }}
                            data-tooltip-id="vendor-tip"
                            data-tooltip-content="Actions"
                            title='Toggle Status'
                        >
                            <div className="form-check form-switch custom-switch">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    style={{ cursor: 'pointer' }}
                                    checked={row.original.is_active}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleStatus(row);
                                    }}
                                />
                            </div>
                            <img
                                src={edit}
                                style={{ cursor: 'pointer' }}
                                alt="Edit"
                                onClick={() => handleEditClick(row.original.id, row)}
                                data-tooltip-id="vendor-tip"
                                data-tooltip-content="Edit Vendor"
                                title='Edit Details'
                            />
                        </div>

                    );
                }
            }


        ],
        []
    );


    const handleSetSearchResults = (data) => {
        setFilterInstitutesBank(Array.isArray(data) ? data : []);
    };

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
        handlePaginate({
            selectedPage: selected,
            url: 'finance/academic-group-fee-discounts/',
            filterQueryString,
            setResults: handleSetSearchResults,
            setTotalCount,
            setFilterQueryString,
        });
    }

    return (
        <>
            {isLoading ? (
                <TableSkeleton rows={10} columns={6} showHeader={true} />
            ) : <div className="dashboard">
                {/* Content for the Dashboard */}
                <div style={{ display: "flex", justifyContent: 'space-between' }}>
                    <div >
                        <h2 className='main-heading'>Manage Bank Accounts</h2>
                    </div>
                </div >
                <div className='row'>
                    <div className="col-md-12 d-flex justify-content-end " style={{ gap: '15px' }}>
                    </div>
                    <div className="row mt-2">
                        {
                            <>  <div className="col-md-12">
                                <div className="row" style={{ alignItems: 'center' }}>
                                    {/* <div className="col-md-6">

                                    </div> */}
                                    <div className="col-md-12">
                                        <div style={{ display: "flex", justifyContent: 'end', gap: "12px" }}>

                                            <button className='add-btn'
                                                onClick={openBankAccountsAddModal}
                                                style={{ padding: '10px 25px' }}>
                                                <span className="me-2">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="22"
                                                        height="22"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    >
                                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                                        <line x1="16" y1="2" x2="16" y2="6" />
                                                        <line x1="8" y1="2" x2="8" y2="6" />
                                                        <line x1="3" y1="10" x2="21" y2="10" />
                                                        <line x1="12" y1="14" x2="12" y2="20" />
                                                        <line x1="9" y1="17" x2="15" y2="17" />
                                                    </svg>


                                                </span>
                                                Add Bank A/Cs
                                            </button>


                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-12">
                                        {filterLoading ? (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    height: '60vh',
                                                    paddingLeft: '28%',
                                                    borderRadius: '8px',
                                                    // backgroundColor: 'red',
                                                }}
                                            >
                                                <SpinnerLoader />
                                            </div>
                                        )
                                            : formattedData && formattedData?.length > 0 ? (
                                                <AdvanceTable
                                                    columns={columns}
                                                    pageCounts={pageCounts}
                                                    handlePageChange={handlePageChange}
                                                    selectedData={selectedInstitutionsBank}
                                                    data={formattedData}
                                                    handleRowClick={handleRowClick}
                                                    currentPage={currentPage}
                                                    checkbox={false}

                                                />
                                            ) : (!isLoading && !isSearchLoading && (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'column', // or row, doesn't matter if justify/align are set
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        height: '60vh', // or 100% of parent container
                                                        color: '#888',
                                                        borderRadius: '8px',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    No Institution's Banks data available.
                                                </div>
                                            )
                                            )}
                                    </div>
                                </div>
                            </div>


                            </>
                        }
                    </div>


                </div >

            </div>}
            <div>
                <AddBankAccounts isOpen={addBankAccountsModal} onClose={closeBankAccountsAddModal} getInstitutionsBank={getInstitutionsBank}
                    editData={selectedInstitutionsBank} currentPage={currentPage}
                    mode={modalMode} />
            </div>

        </>
    );
};


export default ManageBankAccounts